const obj={

    libyAIURL:"https://patinsight.demandintegrate.com/LoginControl"

}

export default obj;